export const LIGHT_COLOR = '#fff';
export const LIGHT_GRAY = '#d7dbdd';
export const BRAND_COLOR = '#0094ff';
export const BLACK_COLOR = '#000000';
export const GRAY_COLOR = '#929292';
export const GREEN_COLOR = '#16a34a';
export const WARNING_COLOR = '#f90';
export const ALERT_TEXT_COLOR = '#f21f1f';
export const GREEN_TEXT_COLOR = '#1d9d39';
